console.log('index.js starting');

import $ from 'jquery';

//vendor files if NPM package isn't available
import './vendor/slick';
import './vendor/jquery.gridder.min.js';
import './vendor/jquery.magnific-popup.min.js';
import './vendor/select2.min.js';

//our files
import App from './app';
import Carrot from './carrot';
import clubOptions from './club';
import clubProfile from './clubProfile';
import Klaviyo from './klaviyo_snippets';
import Events from './events';
import Recipes from './recipes';
import communityModule from './community';
import Shop from './shop';
import C7PDP from './c7-pdp';

import pageScripts from './script.js';
import pageElements from './page-elements.js';

console.log('All modules imported');

$(() => {
  console.log('DOM ready, initializing modules');
  // Initialize global modules
  pageScripts.init();
  pageElements.init();

  App.init();
  Carrot.init();
  clubOptions.init();
  clubProfile.init();
  Klaviyo.init();
  Events.init();
  Recipes.init();
  communityModule.init();
  Shop.init();
  C7PDP.init();

  console.log('All modules initialized');
});

console.log('index.js finished');
